/* ==========================================================================
   VoxTune — "Hear it" compact MP3 popup
   ONLY the HEAR IT player. One global popup; any [data-vp-hear] button opens it
   for that product, using the product's own data-* (image/title/price/handle +
   voxtune.before_audio = Raw, voxtune.after_audio = Preset). Playback runs on
   the single shared audio engine (assets/audio-engine.js) — one instance, one
   track at a time, autoplay on open. No page reload, no redirect, no hardcode.
   This module does NOT touch View All or any other modal.
   ========================================================================== */
(function (w, d) {
  'use strict';
  var VT = w.VoxTune;
  if (!VT) return;

  VT.module('preview', function (VT) {
    var audio = null, root = null, els = {}, lastFocus = null;
    var cur = { pid: null, which: 'before', hasBefore: false, hasAfter: false, frac: 0 };

    function A() { return audio || (audio = VT.use('audio')); }
    function fmt(s) { s = Math.floor(s || 0); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }

    function build() {
      if (root) return root;
      root = d.createElement('div');
      root.className = 'audio-popup';
      root.setAttribute('hidden', '');
      root.innerHTML =
        '<div class="audio-popup__scrim" data-close></div>' +
        '<div class="audio-popup__window" role="dialog" aria-modal="true" aria-label="Audio preview">' +
          '<div class="audio-popup__topbar">' +
            '<span class="audio-popup__dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
            '<span class="audio-popup__code"></span>' +
            '<button type="button" class="audio-popup__close" data-close aria-label="Close">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="audio-popup__content">' +
            '<div class="audio-popup__image"><img alt=""></div>' +
            '<div class="audio-popup__info">' +
              '<div class="audio-popup__info-main"><div class="audio-popup__title"></div><div class="audio-popup__sub"></div></div>' +
              '<div class="audio-popup__price"></div>' +
            '</div>' +
            '<div class="audio-popup__controls">' +
              '<div class="audio-popup__tabs" role="tablist" aria-label="Compare raw and preset">' +
                '<button type="button" class="audio-popup__tab" data-ba="before" role="tab" aria-selected="false">Raw</button>' +
                '<button type="button" class="audio-popup__tab" data-ba="after" role="tab" aria-selected="true">Preset</button>' +
              '</div>' +
              '<button type="button" class="audio-popup__playpause" aria-label="Play or pause">' +
                '<span class="audio-popup__i-play"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span>' +
                '<span class="audio-popup__i-pause"><svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z"/></svg></span>' +
              '</button>' +
            '</div>' +
            '<button type="button" class="audio-popup__waveform" role="slider" aria-label="Seek" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"></button>' +
            '<div class="audio-popup__times"><span class="audio-popup__cur">0:00</span><span class="audio-popup__dur">0:00</span></div>' +
            '<button type="button" class="audio-popup__cart vp-add" data-vp-funnel></button>' +
            '<a class="audio-popup__full" href="#">View full preset &rarr;</a>' +
            '<button type="button" class="audio-popup__back"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 6l-6 6 6 6"/></svg><span class="audio-popup__back-label">Back to presets</span></button>' +
          '</div>' +
        '</div>';
      d.body.appendChild(root);

      var wave = root.querySelector('.audio-popup__waveform'), bars = '';
      for (var i = 0; i < 44; i++) {
        var h = 24 + (((i * 37) + (i % 5) * 13) % 64);
        bars += '<span style="height:' + h + '%;animation-delay:' + ((i % 12) * 70) + 'ms"></span>';
      }
      wave.innerHTML = bars;

      els = {
        code: root.querySelector('.audio-popup__code'),
        img: root.querySelector('.audio-popup__image img'),
        title: root.querySelector('.audio-popup__title'),
        sub: root.querySelector('.audio-popup__sub'),
        price: root.querySelector('.audio-popup__price'),
        tabs: root.querySelectorAll('.audio-popup__tab'),
        playpause: root.querySelector('.audio-popup__playpause'),
        wave: wave,
        bars: wave.querySelectorAll('span'),
        cart: root.querySelector('.audio-popup__cart'),
        full: root.querySelector('.audio-popup__full'),
        back: root.querySelector('.audio-popup__back'),
        backLabel: root.querySelector('.audio-popup__back-label'),
        close: root.querySelector('.audio-popup__close'),
        cur: root.querySelector('.audio-popup__cur'),
        dur: root.querySelector('.audio-popup__dur')
      };

      root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root && !root.hidden) close(); });
      // Keep Tab focus inside the popup while it's open.
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || root.hidden) return;
        var f = root.querySelectorAll('button:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      // Dedicated play/pause; image also toggles.
      els.playpause.addEventListener('click', function () { A().toggle(cur.pid, cur.which); });
      els.img.addEventListener('click', function () { A().toggle(cur.pid, cur.which); });
      // Waveform = seek (pointer click; keyboard-synthesized clicks have detail 0).
      els.wave.addEventListener('click', function (e) { if (!e.detail) return; var r = els.wave.getBoundingClientRect(); A().seek((e.clientX - r.left) / r.width); });
      els.wave.addEventListener('keydown', function (e) {
        var f = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') f = Math.min(1, cur.frac + 0.05);
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') f = Math.max(0, cur.frac - 0.05);
        else if (e.key === 'Home') f = 0; else if (e.key === 'End') f = 0.999;
        if (f !== null) { e.preventDefault(); A().seek(f); }
      });
      Array.prototype.forEach.call(els.tabs, function (t) {
        t.addEventListener('click', function () { if (!t.disabled) setWhich(t.getAttribute('data-ba'), true); });
      });
      // Add to cart → close the popup; funnel.js opens program selection from the
      // same click via [data-vp-funnel].
      els.cart.addEventListener('click', function () { close(); });
      // Mobile "Back to presets" → close + smooth-scroll back to the section.
      els.back.addEventListener('click', function () {
        var tgt = root.getAttribute('data-back') || '#pick-a-preset';
        close();
        scrollToTarget(tgt);
      });
      return root;
    }

    function scrollToTarget(sel) {
      var el; try { el = d.querySelector(sel); } catch (e) { return; }
      if (!el) return;
      var hh = parseInt(getComputedStyle(d.documentElement).getPropertyValue('--vp-header-h'), 10) || 72;
      var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion:reduce)').matches;
      var y = el.getBoundingClientRect().top + w.pageYOffset - hh;
      w.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    }

    function setWhich(which, swap) {
      cur.which = which;
      Array.prototype.forEach.call(els.tabs, function (t) {
        var on = t.getAttribute('data-ba') === which && !t.disabled;
        t.classList.toggle('audio-popup__tab--on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      // A/B compare: swap source but keep the playhead + play/pause state.
      if (swap) A().setWhich(cur.pid, which);
    }

    function open(data) {
      build();
      lastFocus = d.activeElement;
      cur.pid = data.pid || data.handle || 'hear';
      cur.hasBefore = !!data.before;
      cur.hasAfter = !!data.after;

      els.code.textContent = data.sku || '';
      els.code.hidden = !data.sku;
      if (data.image) { els.img.src = data.image; els.img.alt = data.name || ''; els.img.hidden = false; }
      else { els.img.removeAttribute('src'); els.img.hidden = true; }
      els.title.textContent = data.name || '';
      els.sub.textContent = data.subtitle || '';
      els.sub.hidden = !data.subtitle;
      els.price.textContent = data.price || '';
      var fullUrl = data.url || '#';
      els.full.href = /^(https?:\/\/|\/)/.test(fullUrl) ? fullUrl : '#';
      var pb = (VT.shop && VT.shop.previewBack) || {};
      root.setAttribute('data-back', data.backTarget || pb.target || '#pick-a-preset');
      if (els.backLabel) els.backLabel.textContent = data.backLabel || pb.label || 'Back to presets';
      els.cart.textContent = '+ Add to cart' + (data.price ? ' — ' + data.price : '');
      if (data.handle) { els.cart.setAttribute('data-product-handle', data.handle); els.cart.setAttribute('data-product-url', data.url || ''); els.cart.disabled = false; }
      else { els.cart.disabled = true; }

      Array.prototype.forEach.call(els.tabs, function (t) {
        var ok = t.getAttribute('data-ba') === 'before' ? cur.hasBefore : cur.hasAfter;
        t.disabled = !ok;
        t.classList.toggle('audio-popup__tab--disabled', !ok);
      });

      // Load this product's pair into the one shared engine, then auto-play.
      A().load(cur.pid, { before: data.before || null, after: data.after || null, name: data.name || null });
      var which = cur.hasBefore ? 'before' : 'after';
      setWhich(which);

      // Fresh product → reset progress visuals before (auto)playing.
      Array.prototype.forEach.call(els.bars, function (b) { b.classList.remove('on'); });
      if (els.cur) els.cur.textContent = '0:00';
      if (els.dur) els.dur.textContent = '0:00';

      root.hidden = false;
      d.body.style.overflow = 'hidden';
      if (els.close) els.close.focus();
      A().play(cur.pid, which); // HEAR IT click is a user gesture → playback allowed
    }

    function close() {
      if (!root || root.hidden) return;
      A().pause();
      root.hidden = true;
      d.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Reflect the shared engine on the popup (progress, play/pause icon, times).
    VT.on('audio:time', function (e) {
      if (!root || root.hidden || String(e.id) !== String(cur.pid)) return;
      cur.frac = e.fraction || 0;
      if (els.wave) els.wave.setAttribute('aria-valuenow', Math.round(cur.frac * 100));
      var n = els.bars.length, active = Math.floor((e.fraction || 0) * n);
      for (var i = 0; i < n; i++) els.bars[i].classList.toggle('on', i <= active);
      if (els.cur) els.cur.textContent = fmt(e.time);
      if (els.dur && e.duration) els.dur.textContent = fmt(e.duration);
    });
    VT.on('audio:play', function (e) { if (!root) return; var on = String(e.id) === String(cur.pid); root.classList.toggle('is-playing', on); if (on && els.playpause) els.playpause.setAttribute('aria-label', 'Pause'); });
    VT.on('audio:pause', function () { if (root) { root.classList.remove('is-playing'); if (els.playpause) els.playpause.setAttribute('aria-label', 'Play'); } });
    VT.on('audio:ended', function () {
      if (!root) return;
      root.classList.remove('is-playing');
      Array.prototype.forEach.call(els.bars, function (b) { b.classList.remove('on'); });
      if (els.cur) els.cur.textContent = '0:00';
    });

    // Any "Hear it" button opens the popup with its own product's audio.
    d.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-vp-hear]');
      if (!t || t.disabled) return;
      e.preventDefault();
      open({
        pid: t.getAttribute('data-pid'),
        handle: t.getAttribute('data-handle'),
        name: t.getAttribute('data-name'),
        subtitle: t.getAttribute('data-subtitle'),
        price: t.getAttribute('data-price'),
        image: t.getAttribute('data-image'),
        url: t.getAttribute('data-url'),
        sku: t.getAttribute('data-sku'),
        before: t.getAttribute('data-before') || null,
        after: t.getAttribute('data-after') || null,
        backTarget: t.getAttribute('data-back-target'),
        backLabel: t.getAttribute('data-back-label')
      });
    });

    return { open: open, close: close };
  });

  VT.ready(function () { VT.use('preview'); });
})(window, document);
